
Librarian.MessagePreviewWindow = new Class({
    Extends: Librarian.Window,
    Binds: ["setUpColumns", "getTemplates", "initPreviewPanel", "initTemplatePanel", "onTemplateSelect", "getPreview", "setPreviewContent", "save"],

    options: {
        id: "MessagePreviewWindow",
        maximizable: false,
        resizable: true,
        height: 650,
        width: 840,
        toolbar2: true,
        toolbar2Height: 50,
        footerHide: true,

        // Template options
        templateId: -1,   // SupportFileId of template
        eventType: 0,
        allowChangeTemplate: false,
        permissionedTemplates: false,

        // Editor options
        editable: false,
        editMode: false,
        editableSelector: ".editable-area"
    },

    recipientIndex: 0,

    updateInfoFn: null,
    onSave: null,
    onTemplateChange: null,

    previewFrame: null,
    templates: [],
    template: null,

    initialize: function(options) {
        this.setOptions(options);

        this.updateInfoFn = options.updateInfoFn;
        this.onSave = options.onSave;
        this.onTemplateChange = options.onTemplateChange;

        // Set the title on init so that we can use the localization
        this.options.title = Librarian.Lang.getString("message_preview_title");
        this.options.content = '';

        this.options.toolbar2URL = Librarian.path.getLayoutsPath() + "pages/messagepreviewtoolbar.html";

        this.parent(this.options);
    },

    onWindowLoaded: function () {
        this.handlePositionLimits();

        this.loadChain = new Chain();
        this.loadChain.chain(
            //this.getTemplates,
            this.initPreviewPanel
            //,this.initTemplatePanel
        ).callChain();
    },

    onToolbar2Loaded: function() {
        this.setupElements();

        var editCommands = this.getElement("editCommands");
        var previewCommands = this.getElement("previewCommands");
        if (editCommands && previewCommands && this.options.editable) {
            previewCommands.hide();
            editCommands.show();
        }

        var recipientCommands = this.getElement("recipientCommands");
        if (recipientCommands && Librarian.event.previewMultipleRecipients && !this.options.editable) {
            recipientCommands.show();

            this.setupRecipientCommands();
        }

        var itemEl = this.getElement("editButton");
        if (itemEl && this.options.editable) {
            itemEl.show();
            itemEl.addOnClick(function() {
                this.setEditMode(!this.options.editMode);
            }, this);
        }

        itemEl = this.getElement("closeButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("cancelButton");
        if (itemEl)
            itemEl.addOnClick(this.close);

        itemEl = this.getElement("saveButton");
        if (itemEl)
            itemEl.addOnClick(this.save);
    },

    setupRecipientCommands: function() {
        var prevEl = this.getElement("recipientPrev"),
            nextEl = this.getElement("recipientNext"),
            self = this;

        if (prevEl) {
            prevEl.addOnClick(function() {
                self.recipientIndex--;
                self.getPreview();
            });
        }

        if (nextEl) {
            nextEl.addOnClick(function() {
                self.recipientIndex++;
                self.getPreview();
            });
        }
    },

    getTemplates: function() {
        if (this.options.allowChangeTemplate) {
            var method = this.options.permissionedTemplates ? "getpermfis" : "getfis",
                url = Librarian.path.getSupportUrl(method) + "&ftype=" + Librarian.SupportFiles.supportFileTypes.eventTemplate + "&subtype=" + this.options.eventType + "&tmpl=1&out=dgrid";

            var request = new Librarian.Request.JSON({
                url: url,
                onSuccess: function(json) {
                    this.templates = json.data;

                    if (this.templates.length >= 1 && this.options.templateId < 0)
                        this.setTemplate(this.templates[0]);

                    this.loadChain.callChain();
                }.bind(this)
            });
            request.send();
        }
        else
            this.loadChain.callChain();
    },

    initPreviewPanel: function() {
        this.previewColumn = new MUI.Column({
            id: "messagePreviewColumn",
            container: this.contentWrapperEl,
            placement: "main",
            sortable: false
        });

        this.previewPanel = new MUI.Panel({
            id: "messagePreviewPanel",
            contentURL: Librarian.path.getLayoutsPath() + "pages/messagepreviewpanel.html?" + Librarian.buildVersion,
            loadMethod: "iframe",
            column: "messagePreviewColumn",
            collapsible: false,
            header: false,
            onContentLoaded: function() {
                this.previewPanel.contentEl.setStyle("height", "100%");

                this.previewFrame.setStyles({
                    width: "100%",
                    height: "100%"
                });

                // Handle cross-browser cases for loading the document from an iFrame
                var doc = this.previewFrame.contentDocument || this.previewFrame.contentWindow.document;
                this.previewContentEl = doc.getElementById("messagePreviewContent");
                this.getPreview();
            }.bind(this)
        });
        this.previewFrame = this.previewPanel.iframeEl;

        this.loadChain.callChain();
    },

    initTemplatePanel: function() {
        // Only show template panel if there is more than one template to pick from
        if (this.templates.length > 1) {
            var self = this;

            this.templateColumn = new MUI.Column({
                placement: "right",
                id: "messageTemplateColumn",
                container: this.contentWrapperEl,
                sortable: false,
                width: 200,
                resizeLimit: [100, 300]
            });

            this.templatePanel = new MUI.Panel({
                id: "messageTemplatePanel",
                title: "Available Templates",
                column: "messageTemplateColumn",
                content: "",
                collapsible: false,
                padding: {top: 0, left: 0, bottom: 0, right: 0},
                onContentLoaded: function() {
                    for (var i = 0; i < self.templates.length; i++) {
                        var template = self.templates[i];

                        var tempItem = new Element("div");
                        tempItem.data = template;
                        tempItem.addClass("messagePreview-templateItem");
                        if (i == 0)
                            tempItem.addClass("selected");

                        tempItem.addOnClick(function() {
                            self.onTemplateSelect(this);
                        });

                        var description = template.description || Librarian.Lang.getString("message_preview_no_desc");

                        var tempDesc = new Element("div", {
                            text: description
                        });

                        var tempImg = new Element("img");
                        tempImg.src = Librarian.path.getDownloadUrl() + "mode=dsfthmb&tmpl=1&fid=" + template.supportfileid;
                        tempImg.setAttribute("width", "100%");
                        tempImg.removeAttribute("height");

                        tempDesc.inject(tempItem);
                        tempImg.inject(tempItem);
                        tempItem.inject(this.contentEl);
                    }
                }
            });
        }

        this.loadChain.callChain();
    },

    getPreview: function() {
        if (typeof this.updateInfoFn != "function")
            return;

        var eventInfo = this.updateInfoFn(),
            eventSendInfo = {
                event: eventInfo
            };

        // Only send one recipient for the preview
        var recipient = this.getPreviewRecipient(eventInfo.recipients);
        eventInfo.recipients = Array.from(recipient);

        var url = Librarian.path.getEventUrl("getepreview") + "&in=ujson&out=text";
        if (this.options.editable)
            url += "&tmpl=true";

        var request = new Librarian.Request({
            url: url,
            method: "post",
            data: Base64.encode(JSON.stringify(eventSendInfo)),
            onSuccess: this.setPreviewContent,
            onFailure: Librarian.Utils.onFailure
        });
        request.send();
    },

    getPreviewRecipient: function(recipients) {
        if (!recipients || recipients.length == 0)
            return null;

        this.recipientIndex %= recipients.length;

        return recipients[this.recipientIndex];
    },

    setPreviewContent: function(html) {
        if (this.previewContentEl) {
            this.previewContentEl.set("html", html);

            var width = this.previewContentEl.clientWidth;
            if (width > this.options.width) {
                this.options.width = width + 1;
                this.resize();
                this.handlePositionLimits();
            }

            var links = $(this.previewContentEl).getElements("a");
            links.forEach(function(link) {
                link.target = "_blank";
                var href = (link.get("href") || "").trim();

                // Remove invalid portal links (no hash)
                if (href == "" || href.match(/library-dl.*lkey=($|&|#)/)) {
                    link.removeAttribute("href");
                    link.onclick = function() { return false; };
                }
            });

            if (this.options.editable) {
                this.tinyMCE = this.previewFrame.contentWindow.tinyMCE;
                var options = Librarian.Utils.getTinyMCEOptions({
                    toolbar: ["undo redo | bold italic underline strikethrough | alignleft aligncenter alignright | indent outdent | subscript superscript | removeformat | code",
                              "forecolor | fontfamily fontsize | bullist numlist | hr link insertimage insertdisclosure"],
                    selector: this.options.editableSelector,
                    inline: true,
                    height: 150,
                    noneditable_regexp: /{!disclosure.*?}/g,
                    indent_use_margin: true,
                    setup: function(editor) {
                        Librarian.Utils.addTinyMCEButton(editor, "insertimage");
                        Librarian.Utils.addTinyMCEButton(editor, "insertdisclosure");
                    }.bind(this)
                });

                options.plugins += " noneditable";

                this.tinyMCE.init(options);
                this.setEditMode(this.options.editMode);
            }
        }
    },

    setEditMode: function(enabled) {
        this.options.editMode = enabled;
        if (this.previewContentEl)
            this.previewContentEl.toggleClass("editing", enabled);

        this.tinyMCE.get().forEach(function(editor) {
            if (enabled)
                editor.show();
            else
                editor.hide();
        });

        var itemEl = this.getElement("editButton");
        if (itemEl)
            itemEl.value = (enabled ? "Disable" : "Enable") + " Editing";
    },

    onTemplateSelect: function(tempItem) {
        MUI.selected(tempItem, tempItem.parentElement);

        this.setTemplate(tempItem.data);
        this.getPreview();
    },

    setTemplate: function(template) {
        this.template = template;

        if (typeof this.onTemplateChange == "function")
            this.onTemplateChange(template);
    },

    getTemplateId: function() {
        if (this.template)
            return this.template.supportfileid;

        return this.options.templateId;
    },

    save: function () {
        var itemEl = this.getElement("saveButton");
        if (itemEl && itemEl.disabled)
            return;
        Librarian.Utils.setButtonDisabled(itemEl, true);

        if (this.tinyMCE)
            this.tinyMCE.remove();

        if (this.previewContentEl && typeof this.onSave == "function")
            this.onSave(this.previewContentEl);

        this.close();
    },

    onClose: function() {
        this.parent();
    }
});
